export const SERVICES_IN_SERP_FEATURE_FLAG = 'services_in_serp';
export const SWISH_GC_CHECKOUT_FEATURE_FLAG = 'swish_gc_checkout';
export const QLIRO_GC_CHECKOUT_FEATURE_FLAG = 'qliro_gc_checkout';
export const DEALS_FEATURE_FLAG = 'deals_smoke_test';
export const MAPTILER_FEATURE_FLAG = 'use_map_tiler';
export const NEW_PLACE_EXPERIMENT = 'new-place-page';
export const GUEST_LOGIN_SISTAMINUTEN = 'guest-login-sistaminuten';
